var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7643 7.67121L15.9258 3.12305V6.47083C15.9258 7.13584 16.4953 7.67121 17.2028 7.67121H20.7643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8756 1.9043H2.89418C2.18673 1.9043 1.61719 2.43966 1.61719 3.10467V25.2602C1.61719 25.9252 2.18673 26.4606 2.89418 26.4606H18.437C19.1445 26.4606 19.714 25.9252 19.714 25.2602V6.45246",
    fill: "#E2E2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0709 0.875H2.0895C1.38204 0.875 0.8125 1.41037 0.8125 2.07538V24.2309C0.8125 24.8959 1.38204 25.4313 2.0895 25.4313H17.6324C18.3398 25.4313 18.9094 24.8959 18.9094 24.2309V5.42316",
    fill: "#CD4F2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0709 0.875H2.0895C1.38204 0.875 0.8125 1.41037 0.8125 2.07538V24.2309C0.8125 24.8959 1.38204 25.4313 2.0895 25.4313H17.6324C18.3398 25.4313 18.9094 24.8959 18.9094 24.2309V5.42316",
    stroke: "#CD4F2E",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9088 5.42316L14.0703 0.875V4.22279C14.0703 4.88779 14.6399 5.42316 15.3473 5.42316H18.9088Z",
    fill: "#F78B67",
    stroke: "#F78B67",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5974 8.96974C10.6002 8.62834 9.51955 8.61694 8.51536 8.93722C7.51116 9.25751 6.63671 9.89247 6.02131 10.7482C5.40592 11.6039 5.08227 12.635 5.09822 13.6889C5.11417 14.7428 5.46888 15.7636 6.10989 16.6003C6.7509 17.437 7.64418 18.0453 8.6576 18.335C9.67103 18.6247 10.7508 18.5806 11.7372 18.2092C12.7236 17.8378 13.5643 17.1588 14.135 16.2726C14.7056 15.3864 14.9759 14.34 14.9059 13.2883L10.0072 13.6146L11.5974 8.96974Z",
    stroke: "white",
    strokeWidth: 0.875
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70703 20.0957H15.9008",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3655 10.1285C14.7122 10.6113 14.9344 11.1813 15.0107 11.7821L12.0627 12.0068L13.0604 9.04246C13.5734 9.27922 14.0234 9.65213 14.3655 10.1285Z",
    stroke: "white",
    strokeWidth: 0.4375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptxIcon);
export default __webpack_public_path__ + "static/media/pptxIcon.e87992c82f101c3016193241b075159c.svg";
export { ForwardRef as ReactComponent };